<template>
    <div id="HealthConditions">
        <PetButtonDropDown
            :img_src="
                require('@/assets/svg/pet-card-tabs/health/health-condition-colored.svg')
            "
            :name="'Health Conditions'"
            :gray_text="'My health conditions'"
            :bg_color="'rgba(255, 92, 77, 0.1)'"
        >
            <div
                class="details-container"
                v-if="
                    health_condition_que.length == 0 &&
                    loading == false
                "
            >
                <div class="no-details-box">
                    <div
                        class="pic-upload"
                        :style="{
                            'background-image':
                                'url(' +
                                require('@/assets/svg/pet-card-icon/dog-bowl.svg') +
                                ')',
                        }"
                    ></div>
                    <p class="gallery-text">
                        {{ pet_data.name }} does not have any health conditions.
                    </p>
                </div>
            </div>

            <div class="menu-group">
                <XyzTransitionGroup
                    xyz="fade left-100%"
                    v-if="health_condition_que.length > 0 && !loading"
                >
                    <div
                        v-for="(mu, idx) in health_condition_que"
                        :key="idx"
                        class="menu-box"
                    >
                        <div
                            :class="{
                                'menu-item-bar': true,
                                'menu-rounded-top': idx === 0,
                                'menu-rounded-bottom': idx === health_condition_que.length - 1,
                            }"
                        >
                            <span class="icon-text">
                                {{ mu }}
                            </span>
                        </div>
                    </div>

                    <div class="menu-box" key="nav-menu">
                        <div
                            v-if="
                                load_more &&
                                all_health_condition_data &&
                                all_health_condition_data.length > 5
                            "
                            class="menu-item-bar menu-button-nav menu-rounded-bottom"
                            @click="togglePagination()"
                        >
                            Load More
                        </div>
                        <div
                            v-else-if="
                                all_health_condition_data &&
                                all_health_condition_data.length > 5
                            "
                            class="menu-item-bar menu-button-nav menu-rounded-bottom"
                            @click="togglePagination()"
                        >
                            Show Less
                        </div>
                    </div>
                </XyzTransitionGroup>
            </div>
        </PetButtonDropDown>
    </div>
</template>

<script>
import { mapState } from "vuex";
import PetButtonDropDown from "@/petprofile/components/pet/tabs/PetButtonDropDown";

export default {
    name: "HealthConditions",
    components: {
        PetButtonDropDown,
    },
    data() {
        return {
            loading: false,
            health_condition_que: [],
            load_more: true,
            all_health_condition_data: [],
            // pet_data:{health_conditions:[]}
        };
    },
    methods: {
        togglePagination() {
            if (this.health_condition_que.length > 5) {
                this.health_condition_que = this.all_health_condition_data.slice(0, 5);
            } else {
                this.health_condition_que = this.all_health_condition_data;
            }
            this.load_more = !this.load_more;
        },
        async getPetData() {
            this.loading = true;
            this.all_health_condition_data = this.pet_data.health_conditions || [];
            // console.log(this.all_health_condition_data);
            if (this.all_health_condition_data.length <= 5) {
                this.load_more = false;
                this.health_condition_que = this.all_health_condition_data;
            } else {
                this.load_more = true;
                this.health_condition_que = this.all_health_condition_data.slice(0, 5);
            }
            this.loading = false;
            return this.pet_data;
        },
    },
    computed: {
        ...mapState(["userID", "pet_data"]),
    },
    created() {
        this.getPetData();
    },
};
</script>
<style scoped>
#HealthConditions {
    margin: auto;
    padding-bottom: 1rem;
}
.menu-group {
    margin: 0 auto;
}
.menu-button-nav {
    display: flex !important;
    color: var(--primary);
    justify-content: center !important;
    align-items: center !important;
    text-align: center !important;
    margin-top: 1rem;
}
.menu-rounded-top {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}
.menu-rounded-bottom {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
}
.menu-item-bar {
    max-height: 3.5rem;
    background-color: #fff;
    font-size: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    transition: 1s;
    margin: 1px auto;
    padding: 8px 18px;
    background: #fff;
    border: 1px solid rgba(255, 255, 255, 0.18);
}
/* .menu-item-bar:hover{
  transform: translateY(-10px);
} */
.setting-icon {
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
    margin: 0 0.5rem;
}
.icon-text {
    display: flex;
    font-weight: 400;
    font-size: 16px;
    text-transform: capitalize;
    color: #00133d;
    line-height: 24px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.no-details-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.no-details-box img {
    width: 8rem;
    transition: 1s;
    margin: 2rem auto;
}
.pic-upload {
    position: relative;
    width: 12rem;
    height: 12rem;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 70%;
}

.gallery-text {
    font-weight: bold;
    color: #adb6e1;
    text-align: center;
    font-size: 1.3rem;
}

.pic-upload:hover img {
    transform: translateY(-6px);
}

body[data-theme="dark"] #HealthConditions {
    background-color: #222;
    color: var(--text-dark);
    border-color: var(--text-dark);
}
body[data-theme="dark"] .menu-item-bar {
    background-color: #555;
}
/*mobile base */
@media only screen and (max-width: 600px) {
    .menu-group {
        text-align: center;
        /* min-height: 90vh; */
    }
    .menu-item-bar {
        margin: 1px auto;
    }
    .setting-icon {
        width: 1rem;
        height: 1rem;
    }
}
@media only screen and (max-width: 400px) {
}
</style>
